<template>
  <TextInput
    :validate-on-input="true"
    :value="label"
    :label="$t('Title')"
    :classes="'w-full'"
    input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
    name="name"
    type="text"
    :placeholder="$t('Title')"
    @update:modelValue="
      (e) => {
        label = e
        setComponentData()
      }
    " />

  <label class="mt-1.5 ml-4">{{ $t("Show on") }}:</label>
  <div class="flex w-full gap-1 mb-3">
    <div class="w-1/2">
      <SelectInput
        v-model="linked_to"
        :disabled="disabled_connect_to_selection"
        name="select_input"
        :allow-null="false"
        :items="data_source_options"
        :is-box-background="true"
        :value="linked_to"
        label-attr="name"
        value-attr="value"
        :placeholder="$t('Data source')"
        :label="$t('Data source')"
        class="w-full"
        input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm" />
    </div>
    <div class="w-1/2">
      <CompaniesSelect
        v-if="linked_to == 'specific_record'"
        :multi-select="false"
        :disabled="false"
        :companies="linked_record ? [linked_record] : []"
        :label="$t('Selected Record')"
        class="w-full z-50"
        @changed="
          ($event) => {
            if ($event) {
              linked_record = $event[0]?.id
              if ($route.name == 'CompanyProfile' || $route.name == 'ObjectProfile') {
                page = 'record_page'
              } else {
                page = 'specific_record'
              }
              setComponentData()
            }
          }
        " />
    </div>
  </div>

  <div class="flex flex-row justify-between w-full gap-2">
    <div class="w-1/2 m-0 cancel-btn" @click="is_loading ? null : $emit('cancel')">
      {{ $t("Cancel") }}
    </div>
    <button
      :class="[!label ? 'opacity-50' : '']"
      :disable="!label || (linked_to == 'specific_record' && !linked_record)"
      type="button"
      class="w-1/2 primary-btn"
      @click="updateAssets()">
      {{ is_loading ? $t("Loading...") : assetsToEdit ? $t("Update Assets") : $t("Create Assets") }}
    </button>
  </div>
</template>

<script>
import SelectInput from "@/components/shared/SelectInput.vue"
import CompaniesSelect from "@/components/shared/CompaniesSelect.vue"
import TextInput from "@/components/shared/TextInput.vue"

export default {
  components: { SelectInput, TextInput, CompaniesSelect },
  props: {
    assetsToEdit: {
      type: Object,
      default: null
    }
  },
  emits: ["setComponentData", "cancel", "submitForm"],
  data() {
    return {
      label: null,
      is_loading: false,

      linked_record: null,
      page: null,
      linked_to: null,
      data_source_options: [],
      disabled_connect_to_selection: false
    }
  },

  watch: {
    linked_to() {
      if (this.linked_to == "this_record") {
        this.linked_record = this.$route.params.cid
        this.page = "record_page"
      } else if (this.linked_to == "specific_record") {
        this.page = "specific_record"
        this.linked_record = null
      } else {
        this.page = "this_page"
        this.linked_record = "this_page"
      }
      this.setComponentData()
    }
  },

  created() {
    if (this.$route.name == "CompanyProfile" || this.$route.name == "ObjectProfile") {
      this.data_source_options = [
        { name: this.$t("This record"), value: "this_record" },
        { name: this.$t("Specific record"), value: "specific_record" }
      ]
      this.linked_to = "this_record"
      this.linked_record = this.$route.params.cid
    } else {
      this.data_source_options = [
        { name: this.$t("This page"), value: "this_page" },
        { name: this.$t("Specific record"), value: "specific_record" }
      ]
      this.linked_to = "this_page"
      this.linked_record = null
    }
    if (this.assetsToEdit) {
      this.disabled_connect_to_selection = true

      this.linked_to = this.assetsToEdit.props.component_props?.linked_to

      this.label = this.$utils.extractValue(this.assetsToEdit.props.component_props.label, "", this.$route)
    }
  },

  methods: {
    setComponentData() {
      this.$emit("setComponentData", {
        required_filled: this.label && this.linked_record,
        recordId: this.linked_record,
        label: this.label,
        connectTo: this.page,
        linked_to: this.linked_to
      })
    },
    updateAssets() {
      this.$emit("submitForm", {
        id: this.assetsToEdit?.id,
        label: this.label,
        recordId: this.linked_record,
        component_type: "assets",
        connectTo: this.page,
        linked_to: this.linked_to
      })
    }
  }
}
</script>
